module.exports = __webpack_public_path__ + "static/media/call.7c305167.svg";